const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ebg_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function adminLogin(email, password) {
  const res = await fetch(`${API}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Login failed");
  }
  const data = await res.json();
  setToken(data.token);
  return data;
}

export async function adminMe() {
  const res = await fetch(`${API}/auth/me`, { headers: { ...authHeaders() } });
  return res.ok ? res.json() : null;
}

export async function submitLead(payload) {
  try {
    const res = await fetch(`${API}/leads`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Request failed");
    return await res.json();
  } catch (e) {
    // Non-blocking: UI still shows success, but log for debugging
    console.error("Lead submit failed:", e);
    return null;
  }
}

export async function fetchLeads(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${API}/leads${qs ? `?${qs}` : ""}`, { headers: { ...authHeaders() } });
  if (res.status === 401) throw new Error("unauthorized");
  return res.ok ? res.json() : [];
}

export async function fetchLeadStats() {
  const res = await fetch(`${API}/leads/stats`, { headers: { ...authHeaders() } });
  if (res.status === 401) throw new Error("unauthorized");
  return res.ok ? res.json() : { total: 0, by_type: {}, by_status: {} };
}

export async function updateLeadStatus(id, status) {
  const res = await fetch(`${API}/leads/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify({ status }),
  });
  return res.ok ? res.json() : null;
}

export async function deleteLead(id) {
  const res = await fetch(`${API}/leads/${id}`, { method: "DELETE", headers: { ...authHeaders() } });
  return res.ok;
}
